import type {ReactElement} from 'react';
import type {VoiceProfilesDropdownPopupProps} from './voice-profiles-dropdown-popup.types';
import type {PlayableSubfilter} from '@Panels/ai-voice-panel/ai-voice-panel.types';
import {getSelectableVoiceFiltersForLanguage} from '@Panels/ai-voice-panel/ai-voice-panel.library';
import {VoiceProfileItem} from '../voice-profile-item/voice-profile-item';

export function VoiceProfilesDropdownPopup(props: VoiceProfilesDropdownPopupProps): ReactElement<HTMLDivElement> {
  const {selectedProfileId, isSmallScreen} = props;

  return (
    <div className={`ct-neutral-primary gap-2 ${isSmallScreen ? 'spacing-p-b-4' : 'spacing-p-b-2'} flexbox flex-column`}>
      {getSelectableVoiceFiltersForLanguage(props.language).map((profile: PlayableSubfilter) => {
        return <VoiceProfileItem key={profile.id} profile={profile} isSelected={selectedProfileId === profile.id} onProfileSelected={props.onProfileSelected} />;
      })}
    </div>
  );
}
